<template>
  <jet-action-section>
    <template #title>Archive account</template>

    <template #description>
      <div class="my-3">
        Disable your account. Once your account is archived, you will no longer be able to log in,
        but your session data and involvement in sessions will remain accessible for students. You
        can reactivate your account at any time by contacting support.
      </div>
    </template>

    <template #content>
      <div class="mt-5 mb-2">
        <jet-danger-button data-cy="clinician-delete-account" @click="confirmUserDeletion">
          Archive account
        </jet-danger-button>
        <jet-secondary-button class="float-right" type="button" @click="openIntercom">
          Contact support
        </jet-secondary-button>
      </div>

      <!-- Delete Account Confirmation Modal -->
      <jet-dialog-modal :show="confirmingUserDeletion" @close="closeModal">
        <template #title><span class="text-vice-teal-900">Archive account</span></template>

        <template #content>
          <span class="text-vice-teal-900">
            Are you sure you want to archive your account? Once your account is archived, you will
            no longer be able to log in, but your session data and involvement in sessions will
            remain accessible for students. You can reactivate your account at any time by
            contacting support.
          </span>
          <div class="mt-4">
            <jet-input
              data-cy="clinician-delete-account-password"
              type="password"
              class="mt-1 block w-3/4"
              placeholder="Password"
              ref="password"
              v-model="form.password"
              @keyup.enter="deleteUser"
            />

            <jet-input-error :message="form.errors.password" class="mt-2" />
          </div>
        </template>

        <template #footer>
          <jet-secondary-button data-cy="clinician-delete-account-cancel" @click="closeModal">
            Cancel
          </jet-secondary-button>

          <jet-danger-button
            data-cy="clinician-delete-account-confirm"
            class="ml-2"
            @click="deleteUser"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Archive account
          </jet-danger-button>
        </template>
      </jet-dialog-modal>
    </template>
  </jet-action-section>
</template>

<script>
import { showNewMessage } from '@intercom/messenger-js-sdk';
import JetActionSection from '@/Jetstream/ActionSection.vue';
import JetDialogModal from '@/Jetstream/DialogModal.vue';
import JetDangerButton from '@/Jetstream/DangerButton.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';

export default {
  components: {
    JetActionSection,
    JetDangerButton,
    JetDialogModal,
    JetInput,
    JetInputError,
    JetSecondaryButton,
  },

  data() {
    return {
      confirmingUserDeletion: false,

      form: this.$inertia.form({
        password: '',
      }),
    };
  },

  methods: {
    confirmUserDeletion() {
      this.confirmingUserDeletion = true;

      setTimeout(() => this.$refs.password.focus(), 250);
    },

    deleteUser() {
      this.form.post(route('clinician-current-user.destroy'), {
        preserveScroll: true,
        onSuccess: () => this.closeModal(),
        onError: () => this.$refs.password.focus(),
        onFinish: () => this.form.reset(),
      });
    },

    closeModal() {
      this.confirmingUserDeletion = false;

      this.form.reset();
      this.form.errors.password = '';
    },

    openIntercom() {
      showNewMessage();
    },
  },
};
</script>
